import { apiClient } from './client.tsx';
import { CreateRemittanceInstructionRequest } from './requests/create-remittance-instruction-request.ts';

export const fetchRemittanceInstructions = () =>
  apiClient
    .get('/maas_billing/remittance_instructions?state=READY')
    .then((res) => res.data.data);

export const fetchRemittanceInstruction = (id: string) =>
  apiClient
    .get(`/maas_billing/remittance_instructions/${id}`)
    .then((res) => res.data.data);

export const createRemittanceInstruction = (
  data: CreateRemittanceInstructionRequest,
) =>
  apiClient
    .post('/maas_billing/remittance_instructions', data)
    .then((res) => res.data.data);

export const voidRemittanceInstruction = (id: string) =>
  apiClient
    .delete(`/maas_billing/remittance_instructions/${id}`)
    .then((res) => res.data.data);

export const completeRemittanceInstruction = (
  id: string,
  remittanceDateTime: string,
) =>
  apiClient
    .post(`/maas_billing/remittance_instructions/${id}/complete`, {
      remittanceDateTime: remittanceDateTime,
    })
    .then((res) => res.data.data);

export const fetchRemittanceInstructionURL = (id: string) =>
  apiClient
    .get(`/maas_billing/remittance_instructions/${id}/excel_file_url`)
    .then((res) => res.data.data.url);
